document.addEventListener('DOMContentLoaded', () => {
	// Find all taxonomy-listing blocks with pagination enabled 
	const paginatedBlocks = document.querySelectorAll('.wp-block-plaudit-taxonomy-listing[data-paginate="true"]');

	paginatedBlocks.forEach((block) => {
		const blockElement = block as HTMLElement;
		
		// Get configuration from data attributes
		const batchSize = parseInt(blockElement.dataset.batchSize || '9');
		const taxonomy = blockElement.dataset.taxonomy || 'category';
		const orderby = blockElement.dataset.orderby || 'name';
		const featuredTerms = blockElement.dataset.featuredTerms || '[]';
		const excludeTerms = blockElement.dataset.excludeTerms || '[]';
		const baseUrl = blockElement.dataset.baseUrl || '';
		
		// Find the pagination container and button
		const paginationContainer = blockElement.querySelector('.taxonomy-listing__pagination') as HTMLElement;
		const showMoreButton = blockElement.querySelector('.taxonomy-listing__show-more') as HTMLButtonElement;
		
		if (!showMoreButton || !paginationContainer) {
			return;
		}

		// Track current offset
		let currentOffset = parseInt(showMoreButton.dataset.offset || String(batchSize));

		// Handle Show More button click
		showMoreButton.addEventListener('click', async () => {
			// Disable button and show loading state
			showMoreButton.disabled = true;
			showMoreButton.classList.add('is-loading');
			const originalText = showMoreButton.textContent;
			showMoreButton.textContent = 'Loading...';

			try {
				// Build API URL
				const apiUrl = new URL('/wp-json/plaudit/base/v1/taxonomy-listing', window.location.origin);
				apiUrl.searchParams.set('taxonomy', taxonomy);
				apiUrl.searchParams.set('orderby', orderby);
				apiUrl.searchParams.set('featured_terms', featuredTerms);
				apiUrl.searchParams.set('exclude_terms', excludeTerms);
				apiUrl.searchParams.set('base_url', baseUrl);
				apiUrl.searchParams.set('offset', String(currentOffset));
				apiUrl.searchParams.set('batch_size', String(batchSize));

				// Fetch next batch
				const response = await fetch(apiUrl.toString());
				
				if (!response.ok) {
					throw new Error('Failed to load more items');
				}

				const data = await response.json();

				// Insert new items before the pagination container
				if (data.items) {
					const tempDiv = document.createElement('div');
					tempDiv.innerHTML = data.items;
					
					// Insert each item before the pagination container
					while (tempDiv.firstChild) {
						paginationContainer.parentNode?.insertBefore(tempDiv.firstChild, paginationContainer);
					}
				}

				// Update offset
				currentOffset += batchSize;
				showMoreButton.dataset.offset = String(currentOffset);

				// Hide button if no more items
				if (!data.has_more) {
					showMoreButton.style.display = 'none';
				}

				// Re-enable button and restore text
				showMoreButton.disabled = false;
				showMoreButton.classList.remove('is-loading');
				showMoreButton.textContent = originalText;

			} catch (error) {
				console.error('Error loading more taxonomy items:', error);
				
				// Re-enable button and show error
				showMoreButton.disabled = false;
				showMoreButton.classList.remove('is-loading');
				showMoreButton.textContent = 'Error - Try Again';
				
				// Reset text after 3 seconds
				setTimeout(() => {
					showMoreButton.textContent = originalText;
				}, 3000);
			}
		});
	});
});
